<script setup lang="ts">
import { Head, router } from '@inertiajs/vue3'
import { Clock } from 'lucide-vue-next'

import { Button } from '@/components/ui/button'
import LandingLayout from '@/layouts/LandingLayout.vue'
import { applyPagePath } from '@/routes'

defineProps<{
  customer_name?: string | null
  portal_login_url?: string | null
}>()

function applyForAnother() {
  localStorage.removeItem('tlc_customer_id')
  localStorage.removeItem('tlc_application_id')
  router.visit(applyPagePath())
}
</script>

<template>
  <Head title="Application In Progress" />
  <LandingLayout>
    <div class="flex flex-col items-center gap-6 py-12 text-center">
      <Clock class="text-amber-500 size-16" />
      <div class="flex flex-col items-center gap-2">
        <h1 class="text-2xl font-bold">
          <template v-if="customer_name">Hi {{ customer_name }}, you already have an application in progress!</template>
          <template v-else>Application Already In Progress</template>
        </h1>
        <p class="text-muted-foreground mt-2 max-w-md">
          You already have a loan application being processed by the TLC team.
          Track it through the customer portal, or start a new application for a different person.
        </p>
      </div>
      <div class="flex flex-col items-center gap-3 sm:flex-row">
        <Button v-if="portal_login_url" :as="'a'" :href="portal_login_url">Track my application</Button>
        <Button variant="outline" @click="applyForAnother">
          Apply for a different person
        </Button>
      </div>
    </div>
  </LandingLayout>
</template>
